import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useUIComponents, use, useTranslate } from "@bluelibs/x-ui";
import * as Ant from "antd";
import { ExternalCreateForm } from "../../config/ExternalCreateForm";
import { useAppGuardian } from "@bundles/UIAppBundle/services/AppGuardian";
const formLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
};
const formTailLayout = {
    wrapperCol: { offset: 8, span: 16 },
};
export function ExternalsCreate() {
    const UIComponents = useUIComponents();
    const t = useTranslate();
    const { state } = useAppGuardian();
    const form = use(ExternalCreateForm, { transient: true });
    form.setUser(state === null || state === void 0 ? void 0 : state.user);
    form.build();
    return (_jsxs(UIComponents.AdminLayout, { children: [_jsx(Ant.PageHeader, { title: t("management.externals.create.header"), onBack: () => window.history.back() }, void 0), _jsx(Ant.Card, { children: _jsxs(Ant.Form, Object.assign({}, formLayout, { requiredMark: "optional", onFinish: (document) => form.onSubmit(document) }, { children: [form.render(), _jsx(Ant.Form.Item, Object.assign({}, formTailLayout, { children: _jsx(Ant.Button, Object.assign({ type: "primary", htmlType: "submit" }, { children: t("generics.submit") }), void 0) }), void 0)] }), void 0) }, void 0)] }, void 0));
}
